import useTranslation from "../../hooks/useTranslation";
import configStore from "../../stores/ConfigStore";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <ul className="container">
      <li>
        {new Date().getFullYear()} Vekilet - {t("copyright")} ©
      </li>
      <li>
        <a href="mailto:info@vekilet.com">
          <i className="fa fa-envelope" />
          {t("contact-us")}: info@vekilet.com
        </a>
      </li>
      <li>
        <a
          href={`https://vekilet.com/${configStore.currentLanguage}/faq`}
          target="_blank"
        >
          {t("faq")}
        </a>
        &nbsp;{" | "}&nbsp;
        <a
          href={`https://vekilet.com/${configStore.currentLanguage}/how-to`}
          target="_blank"
        >
          {t("how-to")}
        </a>
        &nbsp;{" | "}&nbsp;
        <a href="https://vekilet.com/privacy-policy" target="_blank">
          {t("privacy-policy")}
        </a>
      </li>
    </ul>
  );
};

export default Footer;
